import { ComponentType } from '@angular/cdk/overlay';
import { createAction, props } from '@ngrx/store';
import { IRBPlus, viewMoreDates } from '../types';
import { ReviewHold } from '@submissions/v1/models/submission.model';

const fetchViewMoreDates = createAction(
  '[Submission] View More Dates',
  props<{ submissionId: string }>(),
);

const onfetchViewMoreDatesSuccess = createAction(
  '[Submission] View More Dates Success',
  props<{ payload: viewMoreDates }>(),
);

const onfetchViewMoreDatesFailure = createAction(
  '[Submission] View More Dates Failure',
  props<{ error: any }>(),
);

/*
 * @View More Dates Actions
 */

export const VIEW_MORE_DATE_ACTIONS = {
  fetchViewMoreDates,
  onfetchViewMoreDatesSuccess,
  onfetchViewMoreDatesFailure,
};

/*
 * @Submission Header Actions
 */

const updateIRBPlus = createAction(
  '[SubmissionHeader] Update IRB Plus',
  props<{
    irbState: IRBPlus;
    isAPI?: boolean;
  }>(),
);

const updateIRBPlusSuccess = createAction(
  '[SubmissionHeader] Update IRB Plus Success',
  props<{
    irbState: IRBPlus;
    isAPI?: boolean;
  }>(),
);

export const SUBMISSION_HEADER_ACTIONS = {
  updateIRBPlus,
  updateIRBPlusSuccess,
};

/*
 * @Pririty Dialog Actions
 */

const openPriorityDialog = createAction(
  '[Submission] Open Priority Dialog',
  props<{
    title: string;
    description: string;
    priority: boolean;
    workspaceId: string;
  }>(),
);

export const PRIORITY_DIALOG_ACTIONS = {
  openPriorityDialog,
};

/*
 * @Dialog Actions
 */

const openSubmissionDialog = createAction(
  '[Submission] Open Submission Dialog',
  props<{ component: () => ComponentType<unknown>; data: unknown }>(),
);

export const SUBMISSION_DIALOG_ACTIONS = {
  openSubmissionDialog,
};

const openSubmissionReviewDialog = createAction(
  '[Submission] Open Submission Review Dialog',
  props<{ component: () => ComponentType<unknown>; data: ReviewHold[] }>(),
);

export const SUBMISSION_REVIEW_ACTIONS = {
  openSubmissionReviewDialog,
};
